module.exports = __webpack_public_path__ + "img/pringles.0051ceb9.png";